import React, { useEffect } from 'react';
import { ERROR_RESET_DELAY } from './_constants';
import { ErrorBoundary } from '@/_components/error-boundary';

type TProps = {
  error: Error;
  reset: () => void;
};

export const PageErrorBoundary = ({ error, reset }: TProps) => {
  useEffect(() => {
    // TODO: INS-1744 отправить ошибку в Sentry (https://youtrack.wildberries.ru/issue/INS-1747/FE-Podklyuchit-Sentry-vo-vneshnij-SC)

    const errorInfo = {
      message: error.message,
      stack: error.stack,
      timestamp: new Date().toISOString(),
      userAgent:
        typeof window !== 'undefined' ? window.navigator.userAgent : undefined,
      url: typeof window !== 'undefined' ? window.location.href : undefined,
      digest: (error as Error & { digest?: string }).digest,
    };

    // Структурированное логирование для лучшей читаемости
    // eslint-disable-next-line no-console
    console.group('🚨 Page Error Boundary');
    console.error('Error:', errorInfo.message);
    console.error('URL:', errorInfo.url);
    console.error('Timestamp:', errorInfo.timestamp);
    console.error('Digest:', errorInfo.digest);
    console.error('Stack:', errorInfo.stack);
    // eslint-disable-next-line no-console
    console.groupEnd();
  }, [error]);

  const handleClick = () => {
    setTimeout(() => reset(), ERROR_RESET_DELAY);
  };

  return <ErrorBoundary onClick={handleClick} />;
};
